import { isPlatform } from "@ionic/react";

export const isIOS = isPlatform("ios");
export const isAndroid = isPlatform("android");
export const mobile = isPlatform("hybrid");

// Add specific detection for mobile web browsers
export const isMobileWebBrowser = () => {
    return (
      !isPlatform("hybrid") && // Not a native app
      ("ontouchstart" in window || navigator.maxTouchPoints > 0) && // Touch device
      window.innerWidth <= 1024 // Mobile/tablet screen size
    );
  };

/** Desktop and mobile web browser only (not Capacitor). Used for SEO/GEO article routing. */
export const isWebNotCapacitor = () => !mobile ;

// Detect Chrome on iOS (uses WKWebView but handles viewport-fit=cover differently than Safari)
export const isChromeIOS = () => {
  const ua = navigator.userAgent;
  return /iP(hone|od|ad)/.test(ua) && /CriOS/.test(ua);
};
  